<div class="item-grid-container shadow">
  <div class="realtime-transactions-holder">
    <div class="search-holder">
      <ul class="list-inline grid-top-actions w-90 mb-3">
        <li class="list-inline-item">
          <div class="form-item-input search-dropdown">
            <mat-form-field appearance="outline" class=" p-0 m-0">
              <mat-select
                [(value)]="selectedDays"
                name="pricelist"
                (selectionChange)="changehistory($event)"
              >
                <mat-option
                  [value]="dayCount.days"
                  *ngFor="let dayCount of historyDays"
                >
                  {{ dayCount.value }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </li>
        <li class="list-inline-item">
          <p class="mb-2 mx-2">{{'pages.Creditlinereport.From' | translate }}</p>
        </li>
        
        <li class="list-inline-item">
          <div class="calendar-btn">
            <input
              matInput
              [matDatepicker]="dpFrom"
              [min]="minFromDate"
              placeholder="MM/DD/YYYY"
              [max]="maxDate"
              [formControl]="fromCtrl"
              (dateChange)="changeFromDate($event)"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="dpFrom"
            ></mat-datepicker-toggle>
            <mat-datepicker #dpFrom disabled="false"></mat-datepicker>
          </div>
        </li>
        <li class="list-inline-item">
          <p class="mb-2 mx-2">{{'pages.Creditlinereport.To' | translate }}</p>
        </li>
        <li class="list-inline-item">
          <div class="calendar-btn">
            <input
              matInput
              [matDatepicker]="dpTo"
          
              [min]="minToDate"
              placeholder="MM/DD/YYYY"
              [max]="maxDate"
              [formControl]="toCtrl"
              (dateChange)="changeToDate($event)"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="dpTo"
            ></mat-datepicker-toggle>
            <mat-datepicker #dpTo disabled="false"></mat-datepicker>
          </div>
        </li>
        <li class="list-inline-item">
          <div class="search-holder">
            <input
              type="text"
              placeholder="{{ 'pages.newRetailer.search' | translate }}"
              matInput
              class="
                rounded-pill
                px-3
                py-2
                mb-0
                border-0
                bg-light
                w-100
                me-0
                input-search
                ms-3
              "
              (keyup)="quickSearch()"
              [(ngModel)]="searchValue"
            />
            <i
              color="primary"
              class="search-icon-holder"
              matSuffix
              mat-icon-button
              aria-label="Search"
            >
              <mat-icon>search</mat-icon>
            </i>
          </div>
        </li>
        <li class="list-inline-item float-end">
          <button
          [disabled]="isButtonDisabled"
            mat-stroked-button
            color="primary"
            class=""
            (click)="exportData()"
          >
            <span translate class="translate">pages.newRetailer.download</span>
            <i class="mi mi-save-alt"></i>
          </button>
        </li>
        
        <!-- <li class="list-inline-item">
                  <h4 class="transaction-dates">{{transactionFromDate}} - {{transactionToDate}}</h4>
                </li> -->
        
      </ul>
    </div>
    <hr />
    <div class="stats-blks-holder">
      <div class="d-flex align-items-center align-self-center overflow-wrap">
        <div class="block-each flex-item">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">{{ 'pages.RealtimeTransactions.Sales' | translate}}</h4>
              <p class="card-text values">
                {{ summary.salesSummary | currency }}
              </p>
            </div>
          </div>
        </div>
        <div class="block-each flex-item">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">{{ 'pages.RealtimeTransactions.Netprofit' | translate}}</h4>
              <p class="card-text values">
                {{ summary.netProfit | currency }}
              </p>
            </div>
          </div>
        </div>
        <div class="block-each flex-item">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">{{ 'pages.RealtimeTransactions.Transactions' | translate}}</h4>
              <p class="card-text values">
                {{ summary.totalTransactions }}
              </p>
            </div>
          </div>
        </div>
        <div class="block-each flex-item">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">{{ 'pages.RealtimeTransactions.Promocode' | translate}}</h4>
              <p class="card-text values">
                {{ summary.promoCodeTotalValue | currency }}
              </p>
            </div>
          </div>
        </div>
        <div class="block-each flex-item">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">{{ 'pages.RealtimeTransactions.Purchaseprice' | translate}}</h4>
              <p class="card-text values">
                {{ summary.purchasePriceTotal | currency }}
              </p>
            </div>
          </div>
        </div>
        <div class="block-each flex-item">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">{{ 'pages.RealtimeTransactions.Retailer' | translate}} %</h4>
              <p class="card-text values">
                {{ summary.retailerCommissionTotal | currency }}
              </p>
            </div>
          </div>
        </div>
        <div class="block-each flex-item">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">{{ 'pages.RealtimeTransactions.Salesrep' | translate}} %</h4>
              <p class="card-text values">
                {{ summary.salesRepCommissionTotal | currency }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr class="mb-0" />
    <div class="realtime-transactions-grid-container">
      <ag-grid-angular
        style="width: 100%; height: 60vh"
        class="ag-theme-material"
        [rowHeight]="40"
        [enableFilter]="true"
        [enableSorting]="true"
        [enableColResize]="true"
        [rowSelection]="'single'"
        [rowData]="rowData"
        [columnDefs]="columnDefs"
        (gridReady)="onGridReady($event)"
        (selectionChanged)="onSelectionChanged($event)"
      >
      </ag-grid-angular>
    </div>
  </div>
</div>
